<template>
    <ChildPage page-type="maltStrategyChildPage" />
</template>
<script lang="ts" setup>
    import {useWebsitePageView, definePageMeta} from '#imports';
    import ChildPage from '~/components/ChildPage.vue';

    useWebsitePageView('cms', 'maltstrategy');

    definePageMeta({
        layout: 'maltstrategy',
    });
</script>
